module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-180x180-edd1e3e803599a356ba59813e2d05a95.png";